import $ST from "plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail";
import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { Row, Col, Input, Icon, Tooltip, Form } from "antd";
import $APP from "plugins/tfs/platformConfigs/app";
import { thumbnailImageUrl, isDefined } from "theme/utils";
import Block from "components/ui-ant/Block";
import Image from "theme/Image";

const FormItem = Form.Item;

class PackageItemRow extends Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();

    this.state = {
      // eslint-disable-next-line no-use-before-define
      isInputValueValid,
      isValidationVisible: !!props.initialValue,
      // eslint-disable-next-line no-use-before-define
      showValidationError: !isInputValueValid,
      inputValue: props.initialValue,
      barcodeValue: "",
      _domain: $APP.TITLE,
      // barcodeValue: MNS ? props.packageItem.orderItem.product.attributes.erp_barcode : props.packageItem.orderItem.product.sku
    };

    const isInputValueValid =
      !props.initialValue && this.state.barcodeValue === props.initialValue;
  }

  componentDidUpdate(prevProps, prevState) {
    const { focus, focusOnInputNumber } = this.props;

    if (focusOnInputNumber) return;

    var inputElement = this.inputRef.current && this.inputRef.current.input;
    var isCurrentlyFocused = document.activeElement === inputElement;

    // Check if user was typing in THIS input (inputValue changed)
    var wasTypingHere = prevState.inputValue !== this.state.inputValue;

    // Focus if:
    // 1. focus prop changed from false to true (auto-advance to next input), OR
    // 2. user was typing here and lost focus during re-render
    if (focus && !isCurrentlyFocused && (wasTypingHere || !prevProps.focus)) {
      this.focus();
    }
  }

  componentDidMount() {
    const { focus, focusOnInputNumber, packageItem } = this.props;
    if (!focusOnInputNumber && focus) this.focus();
    this.setState({
      barcodeValue: packageItem.orderItem.product.attributes.integration_edi,
    });
  }

  get isValidationVisible() {
    const { isUIValidationActive } = this.props;
    const { isValidationVisible } = this.state;
    return isValidationVisible && isUIValidationActive;
  }

  get isErrorMessageVisible() {
    const { isUIValidationActive } = this.props;
    const { showValidationError } = this.state;
    return showValidationError && isUIValidationActive;
  }

  focus = () => {
    const { current } = this.inputRef;
    if (current) current.input.focus();
  };

  clear = () => {
    const { current } = this.inputRef;
    const { onBarcodeChange, rowId } = this.props;
    this.setState(
      {
        inputValue: "",
        showValidationError: false,
        isValidationVisible: false,
      },
      () => {
        if (!!current) {
          current.input.value = null;
        }
      },
    );
    onBarcodeChange(true, "", rowId);
  };

  onWeightChange = (e, maxValue) => {
    const { value: weightValue } = e.target;
    const {
      packageItem: { id },
      setWeight,
    } = this.props;
    const maxWeightValue = Number(maxValue);

    if (maxWeightValue >= weightValue) {
      setWeight(id, weightValue);
    } else {
      setWeight(id, maxWeightValue);
    }
  };

  onInputChange = (e) => {
    const { value: inputValue } = e.target;
    const {
      onBarcodeChange,
      setBarcode,
      rowId,
      packageItem: { id },
    } = this.props;

    setBarcode(id, inputValue);
    if (!isDefined(inputValue)) {
      this.setState({
        isInputValueValid: true,
        isValidationVisible: false,
        showValidationError: false,
        inputValue,
      });
      onBarcodeChange(true, inputValue, rowId);
      return;
    }
    if (inputValue === this.state.barcodeValue) {
      this.setState({
        isInputValueValid: true,
        isValidationVisible: true,
        showValidationError: false,
        inputValue,
      });
      onBarcodeChange(true, inputValue, rowId);
    } else {
      this.setState({
        isInputValueValid: false,
        isValidationVisible: true,
        showValidationError: true,
        inputValue,
      });
      onBarcodeChange(false, inputValue, rowId);
    }
  };

  render() {
    const {
      packageItem: {
        orderItem: {
          product: { name, image },
          attributes,
        },
        unit_weight,
      },
      stateEnumValue,
      form: { getFieldDecorator },
    } = this.props;

    const weightType = attributes && attributes.unit_weight_type;
    const weight = attributes && attributes.unit_weight;
    const weightInputDisabled = stateEnumValue !== "100";
    const weightInputVisibility = weightType === "gr";

    const { isInputValueValid, inputValue } = this.state;

    const suffix =
      typeof inputValue === "string" && inputValue.length ? (
        isInputValueValid ? (
          <Icon type="check-circle" className="check-circle-color" />
        ) : (
          <Icon
            onClick={this.clear}
            type="close-circle"
            className="close-circle-color"
          />
        )
      ) : null;

    return (
      <Row className="package-item-row">
        <Col xs={3} sm={3} md={2}>
          <Image
            src={thumbnailImageUrl(image, 32, 32)}
            width={32}
            height={32}
          />
        </Col>
        <Col xs={4} sm={5} md={8} className="package-item-info">
          <Block className="package-item-info--sku">{`Barcode: ${this.state.barcodeValue}`}</Block>
          <Block className="package-item-info--name">{name}</Block>
        </Col>
        <Col xs={7} sm={6} md={4} className="provision-wrapper">
          {weightInputVisibility && (
            <Tooltip placement="leftTop" title="Ürün Miktarı">
              <Form>
                <FormItem>
                  {getFieldDecorator("weightValue", {
                    getValueFromEvent: (e) => {
                      const convertedValue = Number(e.currentTarget.value);
                      if (isNaN(convertedValue)) {
                        return Number(
                          this.props.form.getFieldValue("weightValue"),
                        );
                      } else {
                        return convertedValue;
                      }
                    },
                    rules: [
                      {
                        type: "number",
                        min: 0,
                        max: 1000,
                        message: `Gramaj değeri ${weight}'den yüksek olamaz`,
                      },
                    ],
                    initialValue:
                      (unit_weight && Number(unit_weight)) || weight,
                  })(
                    <Input
                      disabled={weightInputDisabled}
                      onChange={(e) => this.onWeightChange(e, weight)}
                      addonAfter={weightType}
                    />,
                  )}
                </FormItem>
              </Form>
            </Tooltip>
          )}
        </Col>
        <Col xs={10} sm={11} md={10} className="d-flex align-items-center">
          <Input
            ref={this.inputRef}
            placeholder={$ST.SCAN_BARCODE}
            onChange={this.onInputChange}
            suffix={suffix}
            value={inputValue}
            style={{ width: "87.5%", paddingRight: "5px" }}
          />
          {typeof inputValue === "string" && inputValue.length ? (
            <span
              style={{ cursor: "pointer", lineHeight: "initial" }}
              onClick={() => this.clear()}
            >
              Delete
            </span>
          ) : (
            <span></span>
          )}
          {/* {this.isErrorMessageVisible && (
            <Block className="package-item-error">{$ST.WRONG_BARCODE}</Block>
          )} */}
        </Col>
      </Row>
    );
  }
}

PackageItemRow.propTypes = {
  onBarcodeChange: PropTypes.func,
  packageItem: PropTypes.object,
  initialValue: PropTypes.string,
};

const PackageItemRowForm = Form.create()(PackageItemRow);

export default PackageItemRowForm;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/barcode/packageItemRow/index.js